import avatarIconOrangeUrl from './avatar-icon-orange.svg';
import avatarIconWhiteUrl from './avatar-icon-white.svg';
import avatarLogoHorizontalUrl from './avatar-logo-horizontal.svg';

export const brandAssets = {
  iconOrange: avatarIconOrangeUrl,
  iconWhite: avatarIconWhiteUrl,
  /** Wordmark (icon + “avatar”) — staged for later screens */
  logoHorizontal: avatarLogoHorizontalUrl,
} as const;
